import axios from 'axios';
import RestService from '../../helpers/RestService';
import { UPDATE_PROFILE } from '../../modules/profile';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getPlans() {
  try {
    const {data} = await axios.get('/api/plans/get');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function validateUser() {
  try {
    const {data} = await axios.get('/api/payment/valid');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function validCode(code) {
  try {
    const {data} = await axios.post('/api/discount/validate', {code});
    if(data.errcode == 200) {
      return {valid: data.payload, discount: data.discount};
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export async function userPayment(body) {
  try {
    const {data} = await axios.post('/api/payment/post', body);
    if(data.errcode == 200) {
      return data;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}

export function updateProfile(updateData) {
  return (dispatch) => {
    dispatch({
      type : UPDATE_PROFILE,
      payload : {
          updateData,
      },
    });
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/PaymentModal/actions.js